import { BaseApi, CancelTokenKeyCommit } from '@/main/baseApi';
import { SET_CANCEL_TOKEN } from '@/main/store/listEditTypes';

import { DMS_MODULE, NAME as VOZIDLO } from '../constants';
import { NAME } from './constants';

class VozidloCDBProvider extends BaseApi {
	getEntity(cdbVozidloId: string | number) {
		return this.fetch(`/${DMS_MODULE}/${VOZIDLO}/${NAME}/GetCdbVozidloDetail`, { cdbVozidloId });
	}

	tableDataSelect(filter: object, { cancelTokenKey, commit }: CancelTokenKeyCommit = { cancelTokenKey: null, commit: null }) {
		const cancelPtr = cancelTokenKey ? { value: null } : null;
		const resp = this.fetch(`/${this.area}/${VOZIDLO}/${NAME}/Rows`, filter, { cancelPtr });

		cancelTokenKey && commit!(SET_CANCEL_TOKEN, { cancelTokenKey, token: cancelPtr!.value });

		return resp;
	}

	tableSchemaSelect({ cancelTokenKey, commit }: CancelTokenKeyCommit = { cancelTokenKey: null, commit: null }, type: number = 0) {
		const cancelPtr = cancelTokenKey ? { value: null } : null;
		const resp = this.fetch(`/${this.area}/${VOZIDLO}/${NAME}/Schema`);

		cancelTokenKey && commit!(SET_CANCEL_TOKEN, { cancelTokenKey, token: cancelPtr!.value });

		return resp;
	}
}
export const apiProvider = new VozidloCDBProvider(DMS_MODULE, VOZIDLO);
